import { ReactNode, ButtonHTMLAttributes } from 'react';

interface CustomButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

// ✅ Extend native button props so "type", "onClick(e)", "disabled", etc. all work
type ButtonProps = CustomButtonProps & ButtonHTMLAttributes<HTMLButtonElement>;

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  ...props   // <-- spread remaining native props
}: ButtonProps) {
  const baseClasses =
    'font-medium rounded-full transition-all duration-300 flex items-center justify-center whitespace-nowrap cursor-pointer';
  
  const variantClasses = {
    primary: 'bg-[#e18033] text-white hover:bg-[#d16f29] dark:bg-[#e18033] dark:hover:bg-[#d16f29] shadow-lg hover:shadow-xl',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-slate-700 dark:text-gray-200 dark:hover:bg-slate-600 shadow-md hover:shadow-lg',
    outline: 'border-2 border-[#e18033] text-[#e18033] hover:bg-[#e18033] hover:text-white dark:border-[#e18033] dark:text-[#e18033] dark:hover:bg-[#e18033] dark:hover:text-white shadow-md hover:shadow-lg'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  const disabledClasses = props.disabled 
    ? 'opacity-50 cursor-not-allowed' 
    : '';

  return (
    <button
      {...props} // ✅ allows type="submit", onClick(e), disabled, etc.
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`}
    >
      {children}
    </button>
  );
}
